// import { TypographyNumber } from '@/components/elements/numbers';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserRound } from "lucide-react";
import { useMemo } from "react";
import { TypographyNumber } from "@/components/elements/numbers";
import { TMessage } from "@/types/public";

interface Props {
  message: TMessage;
  isLocal: boolean;
}
const formatTime = (s: string) => {
  const date = new Date(s);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
export default function ChatItem({ message, isLocal }: Props) {
  const chatBoxClass = useMemo(() => {
    const mapper: Record<number, string> = {
      0: "flex gap-2 items-end w-full pe-5",
      1: "flex flex-row-reverse gap-2 items-end w-full ps-5",
    };
    return mapper[isLocal ? 0 : 1];
  }, [isLocal]);
  const chatClass = useMemo(() => {
    const mapper: Record<number, string> = {
      0: "flex flex-col min-w-0 max-w-full px-4 py-2 pb-1 mt-1 text-sm bg-gray-200 text-gray-900 rounded-2xl rtl:rounded-bl-sm rtl:rounded-br-2xl ltr:rounded-br-sm ltr:rounded-bl-2xl dark:bg-gray-800 dark:text-gray-100",
      1: "flex flex-col min-w-0 max-w-full px-4 py-2 pb-1 mt-1 text-sm bg-blue-500 text-white rounded-2xl rtl:rounded-br-sm rtl:rounded-bl-2xl ltr:rounded-bl-sm ltr:rounded-br-2xl",
    };
    return mapper[isLocal ? 1 : 0];
  }, [isLocal]);
  const chatTimeSpanClass = useMemo(() => {
    const mapper: Record<number, string> = {
      0: "text-center text-xs font-light text-foreground/60 flex justify-start",
      1: "text-center text-xs font-light text-foreground/60 flex justify-end text-white",
    };
    return mapper[isLocal ? 1 : 0];
  }, [isLocal]);
  return (
    <div className={chatBoxClass}>
      <Avatar className="w-10 h-10 border  ">
        <AvatarImage src="" />
        <AvatarFallback>
          <UserRound strokeWidth={1.5} className="text-gray-600" />
        </AvatarFallback>
      </Avatar>
      <div className={chatClass}>
        {!isLocal && (
          <h6 className="font-medium text-xs text-foreground/60 ">
            {message.senderName}
          </h6>
        )}

        <div className="min-w-0 max-w-full whitespace-pre-wrap break-all [overflow-wrap:anywhere]">
          {message.text}
        </div>
        <div className={chatTimeSpanClass}>
          <TypographyNumber value={formatTime(message.timestamp)} />
        </div>
      </div>
    </div>
  );
}
